<template>
    <div class="hidden touchTablet:flex lg:flex flex-col gap-3 absolute z-30 touchTablet:right-3 touchTablet:bottom-[26rem] lg:right-8 lg:top-1/2 lg:-translate-y-1/2">
        <button
            type="button"
            @click="$emit('previous')"
            :disabled="!canGoPrevious"
            aria-label="Previous clip"
            class="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/10 hover:bg-white/15 shadow-lg lg:w-11 lg:h-11 lg:rounded-lg lg:bg-gray-900/90 lg:backdrop-blur-sm lg:border-gray-700 lg:hover:bg-gray-800/90 lg:shadow-none flex items-center justify-center active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
            <ChevronUp class="w-5 h-5 text-white" />
        </button>
        <button
            type="button"
            @click="$emit('next')"
            :disabled="!canGoNext"
            aria-label="Next clip"
            class="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/10 hover:bg-white/15 shadow-lg lg:w-11 lg:h-11 lg:rounded-lg lg:bg-gray-900/90 lg:backdrop-blur-sm lg:border-gray-700 lg:hover:bg-gray-800/90 lg:shadow-none flex items-center justify-center active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
            <ChevronDown class="w-5 h-5 text-white" />
        </button>
    </div>
</template>

<script setup>
// The clips feed's prev/next pair: desktop and touch tablets. Phones swipe instead.
import { ChevronUp, ChevronDown } from 'lucide-vue-next'

defineProps({
    canGoPrevious: Boolean,
    canGoNext: Boolean,
})

defineEmits(['previous', 'next'])
</script>
